// src/formContext.ts
import * as React from "react";
var formContext = React.createContext(null);
function useFormContext() {
  const formApi = React.useContext(formContext);
  if (!formApi) {
    throw new Error(`You are trying to use the form API outside of a form!`);
  }
  return formApi;
}
export {
  formContext,
  useFormContext
};
//# sourceMappingURL=formContext.js.map